import { useState, useCallback } from 'react';

const galleryImages = [
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/0b49e62303e7642b6f57f753f4bbeb72.jpeg",
    alt: "Prueba de botella de separación agua-crudo en laboratorio – tres muestras con demulsificante RESINVENCA",
    caption: "Prueba de Botella – Separación Óptima",
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/cb6cf83152b2e9f5faae4dff399c104e.jpeg",
    alt: "Probetas graduadas mostrando separación clara de fases agua-crudo con demulsificante RESINVENCA",
    caption: "Separación de Fases en Probeta",
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/5828a834d8607f0e005af60a482065d9.jpeg",
    alt: "Muestra de crudo en botella de prueba tomada directamente en campo petrolero",
    caption: "Prueba de Botella – Campo Real",
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/edad2fece331a7fa1770d7c2620bbf4c.png",
    alt: "Bodega industrial con múltiples contenedores IBC de demulsificante apilados y listos para distribución",
    caption: "Almacenamiento de IBCs en Planta",
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/ac97c662ce0a78a0b34e3dda83ab2d0d.jpeg",
    alt: "Contenedor de exportación con dos totems IBC de demulsificante listos para envío",
    caption: "Totems IBC en Contenedor de Exportación",
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/8af4a4cebc39b301a3468bfbc64db0f6.jpeg",
    alt: "Montacargas cargando totem IBC de demulsificante en camión contenedor en planta China",
    caption: "Carga de Exportación – Planta China",
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/5fd4fc07a5bfa7cb928268f69dd8ae7c.jpeg",
    alt: "Montacargas cargando múltiples totems IBC en contenedor para exportación desde China",
    caption: "Carga de Múltiples IBCs para Exportación",
  },
];

export default function GallerySection() {
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  const openLightbox = useCallback((index: number) => setLightboxIndex(index), []);
  const closeLightbox = useCallback(() => setLightboxIndex(null), []);
  const prevImage = useCallback(() => {
    if (lightboxIndex !== null) {
      setLightboxIndex(lightboxIndex === 0 ? galleryImages.length - 1 : lightboxIndex - 1);
    }
  }, [lightboxIndex]);
  const nextImage = useCallback(() => {
    if (lightboxIndex !== null) {
      setLightboxIndex(lightboxIndex === galleryImages.length - 1 ? 0 : lightboxIndex + 1);
    }
  }, [lightboxIndex]);

  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-10 md:mb-14">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-5">
              <i className="ri-gallery-line text-sm w-4 h-4 flex items-center justify-center"></i>
              Galería de Resultados
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              Resultados que <span className="text-primary-500">Hablan por Sí Solos</span>
            </h2>
            <p className="text-foreground-500 text-sm max-w-xl mx-auto">
              Imágenes reales de pruebas de laboratorio y campo, almacenamiento y logística de exportación desde China.
            </p>
          </div>

          {/* Gallery Grid - Masonry-like layout */}
          <div className="grid grid-cols-1 xs:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {galleryImages.map((image, index) => (
              <div
                key={image.src}
                onClick={() => openLightbox(index)}
                className={`group relative rounded-lg overflow-hidden cursor-pointer border border-background-200/60 hover:border-primary-300/60 transition-all duration-300 select-none ${
                  index === 0 ? "xs:col-span-2 lg:col-span-2" : ""
                } ${index === 3 ? "xs:col-span-2 lg:col-span-2" : ""}`}
              >
                <div className={`overflow-hidden ${index === 0 || index === 3 ? "aspect-[16/9]" : "aspect-[4/3]"}`}>
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500 select-none"
                    draggable="false"
                  />
                </div>
                {/* Anti-download overlay */}
                <div
                  className="absolute inset-0 z-10"
                  onContextMenu={(e) => e.preventDefault()}
                  aria-hidden="true"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4 md:p-5 z-20">
                  <p className="text-white font-heading text-sm md:text-base font-semibold">{image.caption}</p>
                </div>
                <div className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full bg-background-50/90 text-foreground-700 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20">
                  <i className="ri-zoom-in-line text-sm"></i>
                </div>
              </div>
            ))}
          </div>

          {/* CTA below gallery */}
          <div className="text-center mt-10 md:mt-12">
            <a
              href="/productos#galeria"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
            >
              Ver Galería Completa
              <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Lightbox */}
      {lightboxIndex !== null && (
        <div
          className="fixed inset-0 z-[100] bg-foreground-950/95 backdrop-blur-sm flex items-center justify-center p-3 md:p-0"
          onClick={closeLightbox}
          onContextMenu={(e) => e.preventDefault()}
        >
          <button
            onClick={(e) => { e.stopPropagation(); closeLightbox(); }}
            className="absolute top-3 right-3 md:top-5 md:right-5 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/20 text-background-50 hover:bg-background-50/30 transition-all duration-200 cursor-pointer"
          >
            <i className="ri-close-line text-xl"></i>
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); prevImage(); }}
            className="absolute left-3 md:left-8 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background-50/20 text-background-50 hover:bg-background-50/30 transition-all duration-200 cursor-pointer"
          >
            <i className="ri-arrow-left-line text-lg md:text-xl"></i>
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); nextImage(); }}
            className="absolute right-3 md:right-8 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background-50/20 text-background-50 hover:bg-background-50/30 transition-all duration-200 cursor-pointer"
          >
            <i className="ri-arrow-right-line text-lg md:text-xl"></i>
          </button>

          <div className="max-w-5xl w-full mx-3 md:mx-8" onClick={(e) => e.stopPropagation()}>
            <div className="rounded-lg overflow-hidden relative">
              <img
                src={galleryImages[lightboxIndex].src}
                alt={galleryImages[lightboxIndex].alt}
                className="w-full max-h-[60vh] md:max-h-[70vh] object-contain select-none"
                draggable="false"
              />
              {/* Anti-download overlay */}
              <div
                className="absolute inset-0 z-10"
                onContextMenu={(e) => e.preventDefault()}
                aria-hidden="true"
              />
            </div>
            <div className="text-center mt-4">
              <p className="text-white font-heading text-base font-semibold">{galleryImages[lightboxIndex].caption}</p>
              <p className="text-foreground-400 text-xs mt-1">{galleryImages[lightboxIndex].alt}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}